import { boot } from 'quasar/wrappers'
import * as FullStory from '@fullstory/browser';
import { Cookies } from "quasar";

const set_fs_url_cookie = function () {
  if (FullStory.isInitialized()) {
    const url = FullStory.getCurrentSessionURL()
    Cookies.set('fs_url', url, { secure: true, domain: 'comparepower.com', sameSite: 'None', path: '/' });
  }
}

export default boot(({ app }) => {
  FullStory.init({ orgId: process.env.FULL_STORY_ORG_ID }, () => {
    set_fs_url_cookie()
  });
  app.config.globalProperties.$FullStory = FullStory;
})

export { FullStory, set_fs_url_cookie }
